import { Directive, EventEmitter, Output } from '@angular/core';

@Directive()
export class PitchCardModalBase {
  @Output() flagChange = new EventEmitter<{ name: string; value: boolean }>();

  onFlag(name: string, value: boolean) {
    (this as any)[name] = value;
    this.flagChange.emit({ name, value });
  }
}
